"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./index.scss");
var classnames_1 = require("classnames");
var Image_1 = require("mobile/components/Image");
var isomorphismConstant_1 = require("utils/isomorphismConstant");
var StickBottomTab = (function (_super) {
    __extends(StickBottomTab, _super);
    function StickBottomTab() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.showImg = function (item) {
            if (item.icon.ig && item.icon.ig.igroup && item.icon.ig.igroup[isomorphismConstant_1.default.language]) {
                if (!item.icon.link) {
                    return item.icon.ig.igroup[isomorphismConstant_1.default.language].imgTwo;
                }
                else {
                    return item.icon.ig.igroup[isomorphismConstant_1.default.language].img;
                }
            }
            else {
                if (!item.icon.link) {
                    return (item.icon.imgTwo ||
                        (item.icon.ig &&
                            item.icon.ig.igroup &&
                            item.icon.ig.igroup.en &&
                            item.icon.ig.igroup.en.imgTwo));
                }
                else {
                    return (item.icon.img ||
                        (item.icon.ig &&
                            item.icon.ig.igroup &&
                            item.icon.ig.igroup.en &&
                            item.icon.ig.igroup.en.img));
                }
            }
        };
        return _this;
    }
    StickBottomTab.prototype.render = function () {
        var _this = this;
        var _a = this.props, moduleDetail = _a.moduleDetail, id = _a.id;
        var bottomTabArr, backgroundColor;
        if (moduleDetail) {
            bottomTabArr = moduleDetail.module.icons;
            backgroundColor = moduleDetail.ui.bgColor;
        }
        return (React.createElement("div", { className: classnames_1.default(styles.stickBottomTabContainer), style: { backgroundColor: backgroundColor }, id: id }, (bottomTabArr || []).map(function (item, index) {
            var link = _this.showImg(item) || "";
            return (React.createElement("a", { key: index + item.icon.title, href: item.icon.link, "data-src": link },
                React.createElement(Image_1.default, { key: index + item.icon.img, isPostImageToBackground: true, src: link, style: {
                        maxWidth: "100%",
                        maxHeight: "100%"
                    }, isLazyLoad: true, params: "imageView2/2/w/200", alisize: 2 })));
        })));
    };
    return StickBottomTab;
}(React.Component));
exports.default = StickBottomTab;
